export default __webpack_public_path__ + "static/media/follow_icon.f73bca44.svg";